export default "__VITE_ASSET__CKVOxxc3__"